import { DistributionListModel } from '.';

export default class OrganizationUsersModel {
  addExistingUsers: string[];
  inviteUsers: { firstName: string; lastName: string; email: string }[];
  newUser: { firstName: string; lastName: string; email: string };

  constructor(data?: any) {
    this.addExistingUsers = data?.addExistingUsers || [];
    this.inviteUsers = data?.inviteUsers || [];
    this.newUser = data?.newUser || null;
  }
}
